import { WorkflowBadgeController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the workflow badge for object or list item.
 * @example
 * ```html
 * <salaxy-workflow-badge api-ctrl="$ctrl" model="$ctrl.current" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
 * ```
 */
export class WorkflowBadge extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /** Expression for the api controller . */
      apiCtrl: "<",
      /** Object or list item which contains workflow message data. */
      model: "<",
      /** Comma separated list of types to show the badge for. */
      wfTypes: "<",
      /** Visual mode of the component: horizontal or vertical (default). */
      mode: "@"
    };

    /** Uses the WorkflowBadgeController */
    public controller = WorkflowBadgeController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/workflow/WorkflowBadge.html";
}
